import React, { useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./App.css";
import "./styles/home.css";

import logo from "./logo2.png";
import mainLogo from "./logo2.png";
import navbarLogo from "./secundario.png";

import {
  FiBarChart2,
  FiInstagram,
  FiMonitor,
  FiCamera,
  FiTrendingUp,
  FiLayers,
} from "react-icons/fi";

export default function App() {
  const [language, setLanguage] = useState("en");

  const content = {
    en: {
      navServices: "Services",
      navAbout: "About",
      navContact: "Contact",
      navButton: "Schedule A Call",

      heroEyebrow: "Digital Marketing Agency",

      heroTitle1: "We Turn Ideas Into",
      heroTitle2: "Campaigns",
      heroTitle3: "That Sell",

      heroDescription:
        "At Matneu Investment, we create high-performance marketing systems that combine strategy, advertising, content creation, and automation to accelerate business growth.",

      heroButton1: "Schedule A Call",
      heroButton2: "View Services",

      heroCardTitle: "Growth Driven Marketing",

      heroCardDescription:
        "Data, creativity and execution working together to generate measurable results.",

      strategy: "Digital Strategy",
      results: "ROI Focused",

      servicesTitle: "What We Do",

      growthEyebrow: "Why Choose Us",

      growthTitle1: "Marketing That",
      growthTitle2: "Actually Performs",

      growthDescription:
        "We combine paid traffic, content production, web design and analytics to help brands scale faster.",

      features: [
        "Performance focused campaigns",
        "Creative content production",
        "Modern web experiences",
        "Automation & lead generation",
      ],

      ctaTitle: "Ready To Grow Your Brand?",

      ctaDescription:
        "Let's build a marketing strategy tailored to your business goals.",

      ctaButton: "Contact Us",

      footer: "Digital Marketing • Paid Advertising • Brand Growth",
    },

    es: {
      navServices: "Servicios",
      navAbout: "Nosotros",
      navContact: "Contacto",
      navButton: "Agendar Llamada",

      heroEyebrow: "Agencia de Marketing Digital",

      heroTitle1: "Convertimos Ideas En",
      heroTitle2: "Campañas",
      heroTitle3: "Que Venden",

      heroDescription:
        "En Matneu Investment creamos sistemas de marketing de alto rendimiento combinando estrategia, publicidad, contenido y automatización para acelerar el crecimiento de tu negocio.",

      heroButton1: "Agendar Llamada",
      heroButton2: "Ver Servicios",

      heroCardTitle: "Marketing Orientado Al Crecimiento",

      heroCardDescription:
        "Datos, creatividad y ejecución trabajando juntos para generar resultados medibles.",

      strategy: "Estrategia Digital",
      results: "Enfoque ROI",

      servicesTitle: "Lo Que Hacemos",

      growthEyebrow: "Por Qué Elegirnos",

      growthTitle1: "Marketing Que",
      growthTitle2: "Realmente Funciona",

      growthDescription:
        "Combinamos tráfico pago, producción de contenido, diseño web y analítica para ayudar a las marcas a crecer.",

      features: [
        "Campañas orientadas a resultados",
        "Producción de contenido premium",
        "Experiencias web modernas",
        "Automatización y generación de leads",
      ],

      ctaTitle: "¿Listo Para Impulsar Tu Marca?",

      ctaDescription:
        "Construyamos una estrategia de marketing diseñada para tus objetivos.",

      ctaButton: "Contáctanos",

      footer: 
        "Marketing digital, publicidad y estrategias de crecimiento diseñadas para escalar negocios modernos.",
    },
  };

  const t = content[language];

  const services = [
    {
      title:
        language === "en" ? "Marketing Strategy" : "Estrategia de Marketing",
      icon: <FiTrendingUp />,
    },
    {
      title: "Social Media Ads",
      icon: <FiInstagram />,
    },
    {
      title: "Google Ads",
      icon: <FiBarChart2 />,
    },
    {
      title: language === "en" ? "Web Design" : "Diseño Web",
      icon: <FiMonitor />,
    },
    {
      title:
        language === "en" ? "Content Production" : "Producción de Contenido",
      icon: <FiCamera />,
    },
    {
      title:
        language === "en"
          ? "Branding & Automation"
          : "Branding y Automatización",
      icon: <FiLayers />,
    },
  ];

  return (
    <main className="home">
      <Navbar
        logo={navbarLogo}
        t={t}
        language={language}
        setLanguage={setLanguage}
      />

      {/* HERO */}

      <section className="hero">
        <div className="hero-content">
          <span className="eyebrow">{t.heroEyebrow}</span>

          <h1>
            {t.heroTitle1}
            <br />

            <span className="gradient-text">{t.heroTitle2}</span>

            <br />

            {t.heroTitle3}
          </h1>

          <p>{t.heroDescription}</p>

          <div className="hero-actions">
            <a href="#contact" className="btn-primary">
              {t.heroButton1}
            </a>

            <a href="#services" className="btn-secondary">
              {t.heroButton2}
            </a>
          </div>
        </div>

        <div className="hero-card">
          <img src={logo} alt="Matneu" />

          <h3>{t.heroCardTitle}</h3>

          <p>{t.heroCardDescription}</p>

          <div className="stats">
            <div>
              <strong>+360°</strong>
              <span>{t.strategy}</span>
            </div>

            <div>
              <strong>ROI</strong>
              <span>{t.results}</span>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}

      <section id="services" className="section">
        <div className="section-header">
          <h2>{t.servicesTitle}</h2>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <article key={service.title} className="service-card">
              <div className="service-icon">{service.icon}</div>

              <span>0{index + 1}</span>

              <h3>{service.title}</h3>
            </article>
          ))}
        </div>
      </section>

      {/* ABOUT */}

      <section id="about" className="section split">
        <div>
          <span className="eyebrow">{t.growthEyebrow}</span>

          <h2>
            {t.growthTitle1}
            <br />

            <span className="gradient-text">{t.growthTitle2}</span>
          </h2>

          <p>{t.growthDescription}</p>
        </div>

        <div className="features">
          {t.features.map((item) => (
            <div key={item} className="feature">
              <span>✓</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}

      <section id="contact" className="cta">
        <img src={logo} alt="Logo" />

        <h2>{t.ctaTitle}</h2>

        <p>{t.ctaDescription}</p>

        <a href="https://wa.me/" className="btn-primary">
          {t.ctaButton}
        </a>
      </section>

      <Footer logo={mainLogo} t={t} />
    </main>
  );
}
